var path = '/templates/core/views/directives/footer.html';
var html = "<footer class=\"footer zc-footer\"><div class=container><p class=pull-left ng-cloak>{{ thisYear }} Appier Japan, Inc. All rights reserved</p><div class=pull-right><a ui-sref=privacy_policy>{{ 'usersPages.views.directives.footerLinks.privacyPolicy' | translate }}</a> | <a ui-sref=terms_of_service>{{ 'usersPages.views.directives.footerLinks.zcTermsOfUse' | translate }}</a></div></div></footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/views/directives/footer.html
// module id = 1290
// module chunks = 0